var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"pb-2",attrs:{"lg":"4","variant":"info","size":"sm"},on:{"click":_vm.goToOverviewPage}},[_vm._v("Terug naar overzicht")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }